import $ from 'jquery';
import 'what-input';
import 'bxslider/dist/jquery.bxslider.min.js';

// Foundation JS relies on a global varaible. In ES6, all imports are hoisted
// to the top of the file so if we used`import` to import Foundation,
// it would execute earlier than we have assigned the global variable.
// This is why we have to use CommonJS require() here since it doesn't
// have the hoisting behavior.
//window.jQuery = $;
require('foundation-sites');

require("../js/submenu.js"); // submenu functionality

// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
//import './lib/foundation-explicit-pieces';


$(document).foundation();

jQuery(function ($) {
    "use strict";
    $(document).ready(function () { // Loaded when DOM is ready

        cookiebar();

        dynamic_load_posts();

        sliders();

        scrollUpIndicator();

        filters();

        /****************************************
         **** Burger toggle
         ****************************************/
        var menu_active = false; // use this when you want to detect if burger is active
        $(document).on("click", ".burger, .cross", function (e) {
            e.preventDefault();
            menu_active = toggle_burger(menu_active);
        });

        /**
         * Slow scrolling
         */
        document.querySelectorAll('a[href^="#"]').forEach(anchor => {
            anchor.addEventListener('click', function (e) {
                e.preventDefault();
                document.querySelector(this.getAttribute('href')).scrollIntoView({
                    behavior: 'smooth'
                });
            });
        });
    });


    function filters() {

        $("[data-ajax]").submit(function(e) {
            e.preventDefault();
            $("input[name='page']").val(1);
            do_ajax('[data-ajax]');
        });

        $("[data-ajax] .categories li input").change(function(e){
            e.preventDefault();
            var val = $(this).val();
            
            $("input[name='page']").val(1);
            if(val == 'All') {
                $("[data-ajax] .categories li input").not(this).prop('checked', false);
            } else {
                $("[data-ajax] .categories li input[value='All']").prop('checked', false);
            }

            set_url_parameters('[data-ajax] .categories li input:checked');
            do_ajax('[data-ajax]');
        });

        function set_url_parameters(selector) {
            
            var qs = '';
            $(selector).each(function(index, element) {
                if(index != 0) {
                    qs += '&';        
                }
                qs += "category[]=" + element.id;
            });
    
            console.log(qs);
            window.history.replaceState(null, null, "?"+qs);
            
        }

        $("[data-load-more]").click(function(e){
            e.preventDefault();
            var page = parseInt($("input[name='page']").val());
            var new_page = page + 1;
            var total_posts = $("[data-total-count]");
            $("input[name='page']").val(new_page);
            do_ajax('[data-ajax]');
        });

        function do_ajax(form) {
            var formdata = $(form).serialize();
            var page = parseInt($("input[name='page']").val());
            console.log('formdata', formdata);
            console.log('url', site_vars.ajax_url);
            $.ajax({
                url: site_vars.ajax_url,
                method: 'POST',
                dataType: 'json',
                data: formdata,
                beforeSend: function() {
                },
                success: function(res) {
                    var page = parseInt($("input[name='page']").val());
                    console.log('res', res);
                    if(res.status == 'success') {
                        if(page == 1) {
                            $('[data-ajax-result]').html(res.data);
                        } else {
                            $('[data-ajax-result]').append(res.data);
                        }
                        var items_count = $('[data-ajax-result]').children().length;
                        
                        if(parseInt(items_count) < parseInt(res.found_posts)) {
                            $('[data-load-more]').show();
                            
                        } else {
                            $('[data-load-more]').hide();
                        }
                        
                    }
                    if(res.status == 'error') {
                    }
                },
                error: function(err) {
                }
            });
        }
    }

    // Burger function
    function toggle_burger(menu_active) { // function to toggle burger
        menu_active = menu_active || false;
        toggle_burger_items(menu_active);
        if (menu_active == false) {
            var body_top = $("html").scrollTop();

            $("body").addClass("menu-active");
            menu_active = true;
        } else {
            $("body").removeClass("menu-active");
            menu_active = false;
        }

        return menu_active;
    }

    // The toggle function for the burger items
    function toggle_burger_items(menu_active) {
        menu_active = menu_active || false;
        var items_count = $("#site-navigation li").length;
        var i = 0;
        var time = 50;
        if (menu_active == false) {
            var items_interval = setInterval(function () {
                $("#site-navigation li").eq(i).addClass("item-show");
                i++;
                if (i == items_count) {
                    clearInterval(items_interval);
                }
            }, time)
        } else {
            $("#site-navigation li").removeClass("item-show");
        }
    }

    /*
    cookies
    */
    function cookiebar() {
        /*!
        * jQuery Cookie Plugin v1.4.1
        * https://github.com/carhartl/jquery-cookie
        *
        * Copyright 2006, 2014 Klaus Hartl
        * Released under the MIT license
        */
        (function (factory) {
            if (typeof define === 'function' && define.amd) {
                // AMD (Register as an anonymous module)
                define(['jquery'], factory);
            } else if (typeof exports === 'object') {
                // Node/CommonJS
                module.exports = factory(require('jquery'));
            } else {
                // Browser globals
                factory(jQuery);
            }
        }(function ($) {

            var pluses = /\+/g;

            function encode(s) {
                return config.raw ? s : encodeURIComponent(s);
            }

            function decode(s) {
                return config.raw ? s : decodeURIComponent(s);
            }

            function stringifyCookieValue(value) {
                return encode(config.json ? JSON.stringify(value) : String(value));
            }

            function parseCookieValue(s) {
                if (s.indexOf('"') === 0) {
                    // This is a quoted cookie as according to RFC2068, unescape...
                    s = s.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, '\\');
                }

                try {
                    // Replace server-side written pluses with spaces.
                    // If we can't decode the cookie, ignore it, it's unusable.
                    // If we can't parse the cookie, ignore it, it's unusable.
                    s = decodeURIComponent(s.replace(pluses, ' '));
                    return config.json ? JSON.parse(s) : s;
                } catch (e) {
                }
            }

            function read(s, converter) {
                var value = config.raw ? s : parseCookieValue(s);
                return $.isFunction(converter) ? converter(value) : value;
            }

            var config = $.cookie = function (key, value, options) {

                // Write

                if (arguments.length > 1 && !$.isFunction(value)) {
                    options = $.extend({}, config.defaults, options);

                    if (typeof options.expires === 'number') {
                        var days = options.expires, t = options.expires = new Date();
                        t.setMilliseconds(t.getMilliseconds() + days * 864e+5);
                    }

                    return (document.cookie = [
                        encode(key), '=', stringifyCookieValue(value),
                        options.expires ? '; expires=' + options.expires.toUTCString() : '', // use expires attribute, max-age is not supported by IE
                        options.path ? '; path=' + options.path : '',
                        options.domain ? '; domain=' + options.domain : '',
                        options.secure ? '; secure' : ''
                    ].join(''));
                }

                // Read

                var result = key ? undefined : {},
                    // To prevent the for loop in the first place assign an empty array
                    // in case there are no cookies at all. Also prevents odd result when
                    // calling $.cookie().
                    cookies = document.cookie ? document.cookie.split('; ') : [],
                    i = 0,
                    l = cookies.length;

                for (; i < l; i++) {
                    var parts = cookies[i].split('='),
                        name = decode(parts.shift()),
                        cookie = parts.join('=');

                    if (key === name) {
                        // If second argument (value) is a function it's a converter...
                        result = read(cookie, value);
                        break;
                    }

                    // Prevent storing a cookie that we couldn't decode.
                    if (!key && (cookie = read(cookie)) !== undefined) {
                        result[name] = cookie;
                    }
                }

                return result;
            };

            config.defaults = {};

            $.removeCookie = function (key, options) {
                // Must not alter options, thus extending a fresh object...
                $.cookie(key, '', $.extend({}, options, {expires: -1}));
                return !$.cookie(key);
            };
        }));

        var cookies_selector = '#cookiebar';

        if ($(cookies_selector).length) {
            $("#accept-cookies").click(function (e) {
                e.preventDefault();
                $("#cookiebar").addClass("accepted");
                $.cookie('cookie_accept', true, {expires: 30, path: '/'});
            });

            $(window).scroll(function(){
                var scrollTop = $(window).scrollTop();
                var wHeight = $(window).height();
                // console.log(scrollTop);
                if (scrollTop > wHeight) { // remove cookies after scroll of viewheight
                    $("#cookiebar").addClass("accepted");
                    $.cookie('cookie_accept', true, {expires: 30, path: '/'});
                }
            })
        }
    }

    function dynamic_load_posts() {
        var page = 1;
        $(document).on("click", "#load-more", function(e) {
            e.preventDefault();
            page++;
            var ajax_selector = $(this).attr("data-ajax");
            var $btn = $(this);
            var post_type = $(this).attr("data-post-type");
            var loadtext = $(this).attr("data-loadtext");

            $.ajax({
                url: site_vars.ajax_url,
                method: 'POST',
                dataType: 'html',
                data: {
                    action: 'load_posts',
                    page: page,
                    post_type: post_type
                },
                beforeSend: function() {
                    $btn.text(loadtext);
                },
                success: function(data) {
                    $btn.remove();
                    $(ajax_selector).append(data);
                },
                error: function(err) {
                }
            });

        });

    }

    function sliders() {
        $(".gallery-slider").bxSlider({
            speed: $(".gallery-slider").attr("data-speed") ? parseInt($(".gallery-slider").attr("data-speed")) : 800,
            pager: ($(".gallery-slider li").length > 1) ? true : false,
            controls: ($(".gallery-slider li").length > 1) ? true : false,
            adaptiveHeight: true,
            adaptiveHeightSpeed: 300
        });

        var slideWidth = $(".card-slider li").width();
        var wWidth = $(window).width();
        var card_slider_settings = {
            speed: $(".card-slider").attr("data-speed") ? parseInt($(".card-slider").attr("data-speed")) : 800,
            pager: false,
            controls: ($(".card-slider li").length > 1) ? true : false,
            adaptiveHeight: true,
            minSlides: 1,
            maxSlides: 3,
            slideWidth: slideWidth,
            adaptiveHeightSpeed: 300
        };

        var mobile_slider_settings = {
            speed: $(".slider-mobile").attr("data-speed") ? parseInt($(".slider-mobile").attr("data-speed")) : 800,
            pager: false,
            controls: ($(".slider-mobile").children().length > 1) ? true : false,
            adaptiveHeight: true,
            minSlides: 1,
            maxSlides: 3,
            slideWidth: slideWidth,
            adaptiveHeightSpeed: 300
        };

        var card_slider = $(".card-slider").bxSlider(card_slider_settings);
        mobile_slider(wWidth);
        function mobile_slider(wWidth) {
            if(wWidth < 768 && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                $(".slider-mobile").bxSlider(mobile_slider_settings);
            }
        }

        $(window).resize(function(){
            wWidth = $(window).width();
            slideWidth = $(".card-slider li").width();
            mobile_slider(wWidth);
        });
    }

    function scrollUpIndicator() {
        var wHeight = $(window).height();
        var dHeight = $(document).height();
        var fHeight = $("footer.site-footer").height();
        var bottomIndicator = dHeight - wHeight - fHeight;
        var scrollActive = false;
        $(window).scroll(function(){
            var scrollTop = $(window).scrollTop();
            if (scrollTop > (wHeight / 2) && !scrollActive && bottomIndicator > scrollTop) {
                $("body").addClass("scroll-to-top");
                scrollActive = true;
            } else if(scrollTop <= (wHeight / 2) && scrollActive) {
                $("body").removeClass("scroll-to-top");
                scrollActive = false;
            } else if(bottomIndicator <= scrollTop && scrollActive) {
                $("body").removeClass("scroll-to-top");
                scrollActive = false;
            }
        });

        $(".scroll-up-arrow").click(function(e){
            e.preventDefault();
            $("body, html").animate({
                scrollTop: 0
            }, 500);
        });
    }
});